import { fontFamily } from './fontFamily'
import { scale } from './scale'

export const typography = {
  fontFamily,
  h1: {
    fontSize: `${scale.fontSize.sectionTitle}px`,
    fontWeight: 400,
    lineHeight: 1.1,
  },
  h2: {
    fontSize: `${scale.fontSize.display}px`,
    fontWeight: 400,
    lineHeight: 1.1,
  },
  h3: {
    fontSize: '48px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: `${scale.fontSize.subheading}px`,
    fontWeight: 400,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '31px',
    fontWeight: 400,
    lineHeight: 1.3,
  },
  h6: {
    fontSize: `${scale.fontSize.subheading}px`,
    fontWeight: 400,
    lineHeight: 1.3,
  },
  subtitle1: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  button: {
    fontSize: '16px',
    fontWeight: 400,
    textTransform: 'none',
  },
}
